import { render, staticRenderFns } from "./HotWrapper.vue?vue&type=template&id=f778fb9e&scoped=true&"
import script from "./HotWrapper.vue?vue&type=script&lang=js&"
export * from "./HotWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f778fb9e",
  null
  
)

export default component.exports